/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListOrganicTrafficConfigsOptions,
  ListOrganicTrafficConfigsResponses,
} from '../types/ListOrganicTrafficConfigs'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. Lists every order book with a stored organic activity score configuration. Order books without one are scored with the bot service's own configuration and are not listed.
 * @summary List organic activity score configurations
 * {@link /v1/bots/organic-traffic/config}
 */
export function listOrganicTrafficConfigs<ThrowOnError extends boolean = true>(
  options: Options<ListOrganicTrafficConfigsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListOrganicTrafficConfigsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/bots/organic-traffic/config',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListOrganicTrafficConfigsResponses, ThrowOnError>>,
  )
}
